'use client';

const ContactUsButton = (props) => {
	return (
		<div className="mt-8 flex">
			<a
				className="ptf-btn ptf-btn--secondary mx-auto w-full px-4 py-3"
				href=""
				target="_self"
			>
				{props.text ?? 'Get Your Quote'}
			</a>
		</div>
	);
};

export default ContactUsButton;
